import { Page } from '@roc/feature-app-core';
import { Redirect, Route } from 'react-router';
import { BrowseAppraisals } from '../browseAppraisals';
import { FindAppraiser } from '../findAppraiser';
import { SubmitAppraisal } from '../submitAppraisal';
import { useSubmitAppraisalStore } from '../hooks';
import { AddAppraisalDashboard } from '../addAppraisal';

const APPRAISALS_BASE_PATH = 'appraisals';
const CONVERSATION_ID_PATH = ':conversationId';

export const getAppraisalsRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    appraisals: {
      path: `${basePath}/${APPRAISALS_BASE_PATH}`,
      url: `${baseUrl}/${APPRAISALS_BASE_PATH}`,
      documentTitle: 'Appraisals',
      children: {
        browseAppraisals: {
          path: `${basePath}/${APPRAISALS_BASE_PATH}/browse`,
          url: `${baseUrl}/${APPRAISALS_BASE_PATH}/browse`,
          documentTitle: 'View Appraisals',
        },
        browseAppraisalsBoView: {
          path: `${basePath}/backoffice/${APPRAISALS_BASE_PATH}/browse`,
          url: `${baseUrl}/backoffice/${APPRAISALS_BASE_PATH}/browse`,
          documentTitle: 'View Appraisals',
        },
        conversation: (conversationId?: string) => ({
          path: `${basePath}/${APPRAISALS_BASE_PATH}/conversations/${CONVERSATION_ID_PATH}`,
          url: `${baseUrl}/${APPRAISALS_BASE_PATH}/conversations/${conversationId}`,
          documentTitle: `Appraisal Conversation - ${conversationId}`,
        }),
        submitAppraisal: {
          path: `${basePath}/${APPRAISALS_BASE_PATH}/submit`,
          url: `${baseUrl}/${APPRAISALS_BASE_PATH}/submit`,
          documentTitle: 'Order Appraisal',
        },
        addAppraisal: {
          path: `${basePath}/${APPRAISALS_BASE_PATH}/add-appraisal`,
          url: `${baseUrl}/${APPRAISALS_BASE_PATH}/add-appraisal`,
          documentTitle: 'Add Appraisal',
        },
      },
    },
  };
};

export const getAppraisalsRoutes = (basePath: string, baseUrl: string) => {
  const config = getAppraisalsRoutesConfig(basePath, baseUrl);
  const { submitAppraisalStore } = useSubmitAppraisalStore();

  return {
    ...{
      submitAppraisal: (
        <Route exact path={config.appraisals.children.submitAppraisal.path}>
          <Page routeDefinition={config.appraisals.children.submitAppraisal}>
            <SubmitAppraisal store={submitAppraisalStore} />
          </Page>
        </Route>
      ),
      addAppraisal: (
        <Route exact path={config.appraisals.children.addAppraisal.path}>
          <Page routeDefinition={config.appraisals.children.addAppraisal}>
            <AddAppraisalDashboard />
          </Page>
        </Route>
      ),
      browseAppraisals: (
        <Route
          exact
          path={[
            config.appraisals.children.browseAppraisals.path,
            config.appraisals.children.conversation().path,
          ]}
        >
          <Page routeDefinition={config.appraisals.children.browseAppraisals}>
            <BrowseAppraisals />
          </Page>
        </Route>
      ),
      appraisals: (
        <Route
          path={config.appraisals.path}
          render={() => {
            return (
              <Redirect to={config.appraisals.children.browseAppraisals.url} />
            );
          }}
        />
      ),
      browseAppraisalsBoView: (
        <Route
          exact
          path={[
            config.appraisals.children.browseAppraisalsBoView.path,
            config.appraisals.children.conversation().path,
          ]}
        >
          <Page routeDefinition={config.appraisals.children.browseAppraisalsBoView}>
            <BrowseAppraisals />
          </Page>
        </Route>
      ),
    }
  };
};
